import React from 'react';
import { Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { BodyText, Stack } from '../../../ui';
import { PublicProvider } from '../../../../api/Providers';
import formatProfilePhoto from '../../../../modules/formatters/formatProfilePhoto';
import { NotificationsAlertTriangleIcon } from '../../../ui/Icons/NotificationsAlertTriangleIcon';
import { ImageBox } from '../../../ui/ImageBox/ImageBox';

type InactiveProMessageProps = {
  profile: Pick<PublicProvider, 'name' | 'profile_photo'>;
};

export const InactiveProMessage = ({ profile }: InactiveProMessageProps) => (
  <Inline testID="inactive-profile-message" padding={16}>
    {profile.profile_photo && (
      <ImageBox
        width={90}
        height={90}
        sourceURL={formatProfilePhoto(profile.profile_photo)}
        accessibilityLabel={`${profile.name}'s profile photo`}
      />
    )}

    <Stack padding={8} flexShrink={1}>
      <BodyText testID="inactive-profile-message-text" weight="bold" appearance="large">
        <NotificationsAlertTriangleIcon
          width={20}
          height={20}
          color={BrandColor.Yellow}
          style={{
            // the text we're rendering this icon next to has some built in margins
            // so we must apply some negative/positive margins to align the icon
            // with the text
            marginBottom: -3,
            marginRight: 3,
          }}
        />
        {profile.name}
      </BodyText>
      <BodyText>{`Oops! ${profile.name} is no longer on StyleSeat`}</BodyText>
    </Stack>
  </Inline>
);
